import React, { useContext, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useHistory, useLocation } from 'react-router-dom';
import querystring from 'querystring';
import { TriptychLayout } from '../../components/layout/TriptychLayout';
import EnrollmentExplanation from '../HomePage/components/EnrollmentExplanation';
import CheckList from './components/CheckList';
import { EnrollmentContext } from '../../providers/EnrollmentContextProvider';
import EnrollmentLegalProgress from './components/EnrollmentLegalProgress';
import enrollmentAction from '../../providers/EnrollmentContextProvider/enrollmentAction';
import EnrollmentView from '../../enums/EnrollmentView';
import DeclaringPersonForm from './components/DeclaringPersonForm';
import LegalPersonForm from './components/LegalPersonForm';

const EnrollmentLegal = () => {
  const {
    currentStepEnrollmentLegal,
    currentStepEnrollmentLegalIndex,
    dispatch,
    currentView,
  } = useContext(EnrollmentContext);
  const CurrentStepComponent = currentStepEnrollmentLegal.Component;

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 1);
  }, []);

  useEffect(() => {
    const { stepIndex: stepIndexQuery } = querystring.parse(location.search.substring(1));
    const stepIndex = Number(stepIndexQuery) || 0;

    if (stepIndex !== currentStepEnrollmentLegalIndex) {
      dispatch({
        type: enrollmentAction.SET_STEP_ENROLLMENT_LEGAL_INDEX,
        payload: stepIndex,
      });

      setTimeout(() => window.scrollTo(0, 0), 1);
    }
  }, [currentStepEnrollmentLegalIndex, location.search, dispatch]);

  const viewsComponents = {
    [EnrollmentView.DeclaringPersonForm]: DeclaringPersonForm,
    [EnrollmentView.LegalPersonForm]: LegalPersonForm,
  };

  const CurrentView = viewsComponents[currentView];

  const goToNextStep = () => {
    history.push(
      `/enrolamiento/formulario/juridico?stepIndex=${currentStepEnrollmentLegalIndex + 1}`
    );
  };

  const goToPrevStep = () => {
    history.push(
      `/enrolamiento/formulario/juridico?stepIndex=${currentStepEnrollmentLegalIndex - 1}`
    );
  };

  return CurrentView ? (
    <TriptychLayout noAppendPadding>
      <EnrollmentExplanation />
      <CurrentView />
      <CheckList />
    </TriptychLayout>
  ) : (
    <TriptychLayout noAppendPadding>
      <EnrollmentLegalProgress onBack={goToPrevStep} />
      <Fade key={currentStepEnrollmentLegalIndex}>
        <CurrentStepComponent onFinish={goToNextStep} />
      </Fade>
      <div className="enrollment__background" />
    </TriptychLayout>
  );
};

export default EnrollmentLegal;
